/*
 * Brindes automáticos.
 * - Página de produto: apenas vitrine (nenhuma lógica aqui).
 * - Carrinho: mantém os produtos brinde como itens reais do pedido,
 *   adicionando e removendo conforme o carrinho atinge (ou deixa de atingir)
 *   o mínimo configurado em Configurações do tema > 🎁 Brinde.
 */
(function () {
  'use strict';

  var elConfig = document.getElementById('brinde-config');
  if (!elConfig) return;

  var config;
  try {
    config = JSON.parse(elConfig.textContent);
  } catch (e) {
    return;
  }

  var brindes = config.brindes || [];
  if (!config.ativo || brindes.length === 0) return;

  var idsBrinde = brindes.map(function (b) {
    return b.id;
  });

  var fetchOriginal = window.fetch.bind(window);
  var fila = Promise.resolve(false);

  function raizUrl(caminho) {
    var raiz = (config.rootUrl || '/').replace(/\/$/, '');
    return raiz + caminho;
  }

  function pegarCarrinho() {
    return fetchOriginal(raizUrl('/cart.js'), {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    }).then(function (r) {
      return r.json();
    });
  }

  function postar(caminho, corpo) {
    return fetchOriginal(raizUrl(caminho), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(corpo)
    });
  }

  function ehBrinde(item) {
    return idsBrinde.indexOf(item.variant_id) !== -1;
  }

  // Subtotal ignorando as linhas dos próprios brindes: brinde não pode
  // financiar o próprio gatilho.
  function subtotalSemBrindes(carrinho) {
    return carrinho.items.reduce(function (total, item) {
      return ehBrinde(item) ? total : total + item.final_line_price;
    }, 0);
  }

  function temElegivel(carrinho) {
    var pagos = carrinho.items.filter(function (item) {
      return !ehBrinde(item);
    });
    if (pagos.length === 0) return false;
    return subtotalSemBrindes(carrinho) >= config.minimo;
  }

  function quantidadesNoCarrinho(carrinho) {
    var mapa = {};
    carrinho.items.forEach(function (item) {
      if (ehBrinde(item)) mapa[item.variant_id] = (mapa[item.variant_id] || 0) + item.quantity;
    });
    return mapa;
  }

  // Cliques em sequência entram na fila em vez de serem descartados.
  function sincronizar() {
    fila = fila.then(executarSincronizacao, executarSincronizacao);
    return fila;
  }

  // Resolve para true quando o carrinho foi alterado (a UI precisa ser refeita).
  function executarSincronizacao() {
    return pegarCarrinho()
      .then(function (carrinho) {
        var presentes = quantidadesNoCarrinho(carrinho);

        if (!temElegivel(carrinho)) {
          var remover = {};
          var precisaRemover = false;
          brindes.forEach(function (b) {
            if (presentes[b.id]) {
              remover[String(b.id)] = 0;
              precisaRemover = true;
            }
          });
          if (!precisaRemover) return false;
          return postar('/cart/update.js', { updates: remover }).then(function () {
            return true;
          });
        }

        var faltando = brindes.filter(function (b) {
          return !presentes[b.id];
        });

        // Cliente mexeu na quantidade por fora: brinde é sempre 1.
        var corrigir = {};
        var precisaCorrigir = false;
        brindes.forEach(function (b) {
          if (presentes[b.id] > 1) {
            corrigir[String(b.id)] = 1;
            precisaCorrigir = true;
          }
        });

        var passos = Promise.resolve(false);

        if (faltando.length > 0) {
          passos = passos.then(function () {
            return postar('/cart/add.js', {
              items: faltando.map(function (b) {
                return { id: b.id, quantity: 1, properties: { _brinde: 'true' } };
              })
            }).then(function () {
              return true;
            });
          });
        }

        if (precisaCorrigir) {
          passos = passos.then(function () {
            return postar('/cart/update.js', { updates: corrigir }).then(function () {
              return true;
            });
          });
        }

        return passos;
      })
      .catch(function () {
        return false;
      });
  }

  function trocarConteudo(doc, seletor) {
    var novo = doc.querySelector(seletor);
    var atual = document.querySelector(seletor);
    if (novo && atual) atual.innerHTML = novo.innerHTML;
  }

  function atualizarInterface() {
    var secoes = ['cart-drawer', 'cart-icon-bubble'];
    var itensCarrinho = document.getElementById('main-cart-items');
    var rodapeCarrinho = document.getElementById('main-cart-footer');

    if (itensCarrinho && itensCarrinho.dataset.id) secoes.push(itensCarrinho.dataset.id);
    if (rodapeCarrinho && rodapeCarrinho.dataset.id) secoes.push(rodapeCarrinho.dataset.id);

    var base = itensCarrinho ? config.cartUrl : config.rootUrl || '/';

    return fetchOriginal(base + '?sections=' + secoes.join(','), { credentials: 'same-origin' })
      .then(function (r) {
        return r.json();
      })
      .then(function (secoesHtml) {
        var parser = new DOMParser();

        Object.keys(secoesHtml).forEach(function (id) {
          var doc = parser.parseFromString(secoesHtml[id], 'text/html');

          if (id === 'cart-drawer') {
            trocarConteudo(doc, '#CartDrawer');
          } else if (id === 'cart-icon-bubble') {
            var bolha = document.getElementById('cart-icon-bubble');
            var bolhaNova = doc.querySelector('#cart-icon-bubble');
            if (bolha) bolha.innerHTML = bolhaNova ? bolhaNova.innerHTML : doc.body.innerHTML;
          } else {
            trocarConteudo(doc, '#main-cart-items .js-contents');
            trocarConteudo(doc, '#main-cart-footer .js-contents');
          }
        });

        return pegarCarrinho();
      })
      .then(function (carrinho) {
        var vazio = carrinho.item_count === 0;
        var gaveta = document.querySelector('cart-drawer');
        var itens = document.querySelector('cart-items');
        if (gaveta) gaveta.classList.toggle('is-empty', vazio);
        if (itens) itens.classList.toggle('is-empty', vazio);
        document.dispatchEvent(new CustomEvent('brinde:atualizado', { detail: { carrinho: carrinho } }));
      })
      .catch(function () {});
  }

  // O tema renderiza o carrinho com um HTML capturado ANTES do brinde entrar.
  // Nossa atualização precisa cair depois dessa renderização, senão o snapshot
  // velho sobrescreve o card.
  function agendarAtualizacao() {
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        setTimeout(atualizarInterface, 250);
      });
    });
  }

  function sincronizarEAtualizar() {
    return sincronizar().then(function (mudou) {
      if (mudou) return atualizarInterface();
    });
  }

  var MUTACOES = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;

  window.fetch = function () {
    var args = Array.prototype.slice.call(arguments);
    var entrada = args[0];
    var url = typeof entrada === 'string' ? entrada : (entrada && entrada.url) || '';

    return fetchOriginal.apply(null, args).then(function (resposta) {
      if (!MUTACOES.test(url)) return resposta;

      // Espera os brindes entrarem/saírem antes de devolver a resposta: se o
      // tema for direto pro checkout, o pedido já sai com os brindes dentro.
      return sincronizar().then(function (mudou) {
        if (mudou) agendarAtualizacao();
        return resposta;
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sincronizarEAtualizar);
  } else {
    sincronizarEAtualizar();
  }
})();
